import React, { useState } from "react";
import OtpInput from "react-otp-input";
import UserService from "../../services/user";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";

const VerifyOtp = ({ setIsOpen, modalIsOpen, email, setShowRegister }) => {
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();
  const onSubmit = async () => {
    if (otp) {
      try {
        let { data } = await UserService.verifyOtp({ otp, email });
        if (data.message) {
          toast.success(data.message);
          navigate("/login");
          setIsOpen(false);
        }
      } catch (err) {
        toast.error("OTP is not correct");
      }
    } else {
      toast.error("Please enter the otp");
    }
  };

  const onResend = async () => {
    if (email) {
      try {
        let { data } = await UserService.resendOtp({ email });
        if (data.message) {
          toast.success(data.message);
        }
      } catch (err) {
        toast.error("Something is went wrong!");
        console.log(err);
      }
    }
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '2rem',
      width: '100%',
      maxWidth: '380px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
  };

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={() => {}}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="OTP Verification Modal"
      >
        <h2 style={{ fontSize: '1.8rem', color: '#333', marginBottom: '1.5rem' }}>Enter OTP</h2>
        <span 
          onClick={() => { closeModal(); navigate('/login'); }} 
          style={{
            position: 'absolute',
            top: '15px',
            right: '20px',
            fontSize: '28px',
            cursor: 'pointer',
            color: '#888'
          }}
        >
          &times;
        </span>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderSeparator={<span style={{ width: "1rem" }}></span>}
          renderInput={(props) => <input {...props} style={{ 
            width: "3.5rem", 
            height: "3.5rem", 
            margin: "0 0.4rem", 
            fontSize: "1.5rem", 
            borderRadius: "8px", 
            border: "1px solid #ddd", 
            textAlign: "center" 
          }} />}
        />
        <div style={{ marginTop: '2rem', width: '100%' }}>
          <button 
            style={{
              backgroundColor: '#f0f0f0',
              color: '#555',
              border: 'none',
              padding: '0.8rem 1.5rem',
              borderRadius: '30px',
              cursor: 'pointer',
              marginRight: '1rem',
              fontSize: '1rem',
              fontWeight: '600',
              transition: 'background-color 0.2s ease',
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#e0e0e0'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onClick={onResend}
          >
            Resend
          </button>
          <button 
            style={{
              backgroundColor: '#1f2937',
              color: 'white',
              border: 'none',
              padding: '0.8rem 1.5rem',
              borderRadius: '30px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              transition: 'background-color 0.2s ease',
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#374151'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#1f2937'}
            onClick={onSubmit}
          >
            Verify
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default VerifyOtp;
